export type ToolId =
  | 'all-tools'
  | 'home'
  | 'saas'
  | 'bakers-percentage'
  | 'baking-pan-converter'
  | 'recipe-scaler'
  | 'measurement-converter'
  | 'temperature-converter'
  | 'yeast-converter'
  | 'baking-blog'
  | 'recipe-index'
  | 'about'
  | 'contact-us'
  | 'privacy-policy'
  | 'terms-of-use'
  | 'disclaimer'
  | 'baker-schedule'
  | 'buttercream-calculator'
  | 'cake-pricing'
  | 'cost-per-recipe'
  | 'dough-temperature'
  | 'dough-hydration'
  | 'flavor-pairing-guide'
  | 'fondant-calculator'
  | 'frosting-color-mixer'
  | 'ganache-calculator'
  | 'ingredient-substitutions'
  | 'inventory-management'
  | 'macaron-troubleshooting'
  | 'management-dashboard'
  | 'order-management'
  | 'shopping-list'
  | 'bakery-order-planner'
  // Categories
  | 'core'
  | 'converters'
  | 'management'
  | 'kitchen'
  | 'resources';

export const toolIdToSlug = (toolId: ToolId): string => {
  switch (toolId) {
    case 'home': return '/';
    case 'all-tools': return '/tools/all-tools';
    case 'bakers-percentage': return '/tools/bakers-percentage';
    case 'baking-pan-converter': return '/tools/baking-pan-converter';
    case 'recipe-scaler': return '/tools/recipe-scaler';
    case 'measurement-converter': return '/tools/measurement-converter';
    case 'temperature-converter': return '/tools/temperature-converter';
    case 'yeast-converter': return '/tools/yeast-converter';
    case 'baking-blog': return '/blog';
    case 'recipe-index': return '/recipes';
    case 'about': return '/about';
    case 'contact-us': return '/contact-us';
    case 'privacy-policy': return '/privacy-policy';
    case 'terms-of-use': return '/terms-of-use';
    case 'disclaimer': return '/disclaimer';
    case 'saas': return '/saas';
    case 'baker-schedule': return '/tools/baker-schedule';
    case 'buttercream-calculator': return '/tools/buttercream-calculator';
    case 'cake-pricing': return '/tools/cake-pricing';
    case 'cost-per-recipe': return '/tools/cost-per-recipe';
    case 'dough-temperature': return '/tools/dough-temperature';
    case 'dough-hydration': return '/tools/dough-hydration';
    case 'flavor-pairing-guide': return '/tools/flavor-pairing-guide';
    case 'fondant-calculator': return '/tools/fondant-calculator';
    case 'frosting-color-mixer': return '/tools/frosting-color-mixer';
    case 'ganache-calculator': return '/tools/ganache-calculator';
    case 'ingredient-substitutions': return '/tools/ingredient-substitutions';
    case 'inventory-management': return '/tools/inventory-management';
    case 'macaron-troubleshooting': return '/tools/macaron-troubleshooting';
    case 'management-dashboard': return '/tools/management-dashboard';
    case 'order-management': return '/tools/order-management';
    case 'shopping-list': return '/tools/shopping-list';
    case 'bakery-order-planner': return '/tools/bakery-order-planner';
    case 'core': return '/tools/core';
    case 'converters': return '/tools/converters';
    case 'management': return '/tools/management';
    case 'kitchen': return '/tools/kitchen';
    case 'resources': return '/tools/resources';
    default: return '/';
  }
};

export const allToolIds: ToolId[] = [
  'home', 'all-tools', 'saas', 'baking-blog', 'recipe-index', 'about', 'contact-us', 
  'privacy-policy', 'terms-of-use', 'disclaimer',
  'cake-pricing', 'recipe-scaler', 'cost-per-recipe', 'bakers-percentage',
  'dough-hydration', 'dough-temperature', 'buttercream-calculator',
  'ganache-calculator', 'fondant-calculator', 'frosting-color-mixer',
  'flavor-pairing-guide', 'macaron-troubleshooting', 'ingredient-substitutions',
  'measurement-converter', 'temperature-converter', 'baking-pan-converter',
  'yeast-converter', 'order-management', 'inventory-management',
  'bakery-order-planner', 'management-dashboard', 'shopping-list',
  'baker-schedule', 'core', 'converters', 'management', 'kitchen', 'resources',
];

export const slugToToolId = (slug: string): ToolId | undefined => {
  if (slug === '/') return 'home';
  if (slug === '/blog') return 'baking-blog';
  if (slug === '/recipes') return 'recipe-index';
  if (slug === '/about') return 'about';
  if (slug === '/contact-us') return 'contact-us';
  if (slug === '/privacy-policy') return 'privacy-policy';
  if (slug === '/terms-of-use') return 'terms-of-use';
  if (slug === '/disclaimer') return 'disclaimer';
  if (slug === '/saas') return 'saas';

  let toolId = slug.replace('/tools/', '') as ToolId;
  
  // Alias mapping for legacy links
  if (toolId as string === 'pan-size-calculator') {
    toolId = 'baking-pan-converter';
  }

  if (allToolIds.includes(toolId)) return toolId;
  return undefined;
};
